<template>
  <v-container class="login-page">
    <div class="my-4 form-header text-xs-right">
      <div class="logo">
        <img draggable="false" :src="require('@/assets/soae.png')" alt="Logo" />
        <p>Comunicação</p>
      </div>
    </div>
    <v-layout justify-center align-center>
      <v-card width="500">
        <v-card-title>
          <p class="primary--text ma-0 py-2 form-title headline">
            Resetar senha
          </p>
        </v-card-title>
        <v-form v-model="validate" ref="form">
          <v-card-text>
            <v-flex md12>
              <v-text-field
                v-model="senha.password"
                type="password"
                label="Nova senha"
                required
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex md12>
              <v-text-field
                v-model="senha.password_confirmation"
                type="password"
                label="Confirmar senha"
                required
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-btn
                @click="enviar"
                @keyup.enter="enviar"
                class="primary"
                :loading="loadBtn"
                >Alterar</v-btn
              >
            </v-flex>
          </v-card-text>
        </v-form>
      </v-card>
    </v-layout>
    <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import CryptoJS from 'crypto-js'
import { Password } from '../service'

export default {
  data() {
    return {
      validate: true,
      cor: '',
      snackbar: false,
      text: '',
      senha: {
        password: '',
        password_confirmation: ''
      },
      link: this.$route.query.link,
      escola: this.$route.query.escola,
      token: '',
      email: '',
      loadBtn: false,
      rules: [v => !!v || 'Campo requerido.']
    }
  },
  async created() {
    await this.getDados()
  },
  methods: {
    async getDados() {
      try {
        const dados = await Password.find(this.link, {
          escola: this.escola
        })
        this.email = dados.email
        this.token = dados.token
      } catch (erro) {
        this.snackbar = true
        this.text = 'Este token de redefinição de senha é inválido.'
        this.cor = 'red'
      }
    },
    async enviar() {
      if (this.$refs.form.validate()) {
        this.loadBtn = true
        const newPass = CryptoJS.MD5(this.senha.password).toString()
        const confirmPass = CryptoJS.MD5(
          this.senha.password_confirmation
        ).toString()

        if (newPass == confirmPass) {
          const body = {
            email: this.email,
            password: newPass,
            password_confirmation: confirmPass,
            token: this.token
          }
          try {
            await Password.reset(body, {
              escola: this.escola
            })
            //this.snackbar = true
            //this.text = 'Senha resetada com sucesso'
            setTimeout(() => {
              localStorage.setItem('passreset', 'success')
              this.$router.push({
                name: 'login',
                query: { redirect: '/', escola: this.escola }
              })
            }, 700)
          } catch (erro) {
            this.snackbar = true
            this.text = 'Houve um erro ao resetar a senha.'
            this.cor = 'red'
            this.loadBtn = false
          }
        } else {
          this.snackbar = true
          this.text = 'Senhas diferentes! As senhas devem ser iguais'
          this.cor = 'red'
        }
        this.loadBtn = false
      }
    }
  }
}
</script>

<style lang="stylus">
a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.form-header {
  text-align: center;
  max-width: 180px;
  margin: 0 auto;

  img {
    width: 55%;
    margin-bottom: 5px;
  }

  p {
    font-weight: bold;
    font-size: 14;
    color: #888;
    line-height: 0;
  }
}

.form-title {
  font-weight: bold;
}
</style>
